import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import logo from "../assets/images/aceN_Logo.png";
import loader from "../assets/images/loader.gif";
import viewIcon from "../assets/images/view.png";
import { useLogout, generateId } from "../hooks/Utility";
import {PEButton, PEDiv, PEImg} from './permissionComponents/index';
import useAxios from "../hooks/useAxios";

//const api_token = localStorage.getItem("api_token");
// const effective_designation_id = localStorage.getItem(
//   "effective_designation_id "
// );
function Dashboard(props) {
  const [logout] = useLogout();
  const history = useHistory();
  const location = useLocation();
  const [loading, sendRequest] = useAxios();
  // Extract state from location
  const { 
    effective_designation_id, 
    api_token,
    is_first_login,
    password_update_flag,
    password_age,
    entity_name,
    branch_unit_level_id,
    parent_entity_name,
    max_unit_level_id
  } = (location && location.state) || {};
  
  const [state, setState] = useState({
    showPasswordUpdateModal: is_first_login === "1" || password_update_flag === true || password_age > 90,
    npass: "",
    cpass: "",
    isViewpass: true,
    isViewpass1: true,
    passerr: "",
    SuccessOpen: false,
    isErrOpen: false,
    api_error_message: "",
    isSpin: false
  });

  useEffect(() => {
    document.title = "Dashboard";
    const uid = localStorage.getItem("in_userid");
    if (!uid) {
      localStorage.clear();
      history.push("/");
    }
    if (api_token) {
      localStorage.setItem("api_token", api_token);
    }
  }, [api_token, history]);

  const viewpass = (type) => {
    if (type === 1) {
      setState(prev => ({ ...prev, isViewpass: !prev.isViewpass }));
    } else {
      setState(prev => ({ ...prev, isViewpass1: !prev.isViewpass1 }));
    }
  };

  const comparepass = (e) => {
    const cpass = e.target.value;
    if (state.npass !== cpass) {
      setState(prev => ({ ...prev, cpass, passerr: "Passwords do not match" }));
    } else {
      setState(prev => ({ ...prev, cpass, passerr: "" }));
    }
  };

  const handlemailSubmitpass = async (event) => {
    event.preventDefault();
    const uid = localStorage.getItem("in_userid");

    if (state.passerr) return;
    if (!state.npass || !state.cpass) {
      setState(prev => ({ 
        ...prev, 
        isErrOpen: true, 
        api_error_message: "Please fill all fields" 
      }));
      return;
    }

    setState(prev => ({ ...prev, isSpin: true }));

    const formdata = new FormData();
    formdata.append("userid", uid);
    formdata.append("user_password", state.npass);

    try {
      const response = await sendRequest({
        url: `${process.env.REACT_APP_BASE_URL}/changepassword`,
        data: formdata,
        method: "POST",
        headers: {
          "api-token": api_token,
          "Content-Type": "multipart/form-data",
          component_id: generateId(10),
          apiId: generateId(10),
          api_group_id: "",
          component: "Dashboard",
          user_id: uid,
        },
      });

      if (response.isupdate) {
        setState(prev => ({
          ...prev,
          SuccessOpen: true,
          api_error_message: response.message || "Password updated successfully!",
          isSpin: false,
          showPasswordUpdateModal: false
        }));
      } else {
        throw new Error(response.message || "Password update failed");
      }
    } catch (error) {
      setState(prev => ({
        ...prev,
        isErrOpen: true,
        api_error_message: error.message || "An error occurred while updating password",
        isSpin: false
      }));
    }
  };

  const showBackdrop = state.showPasswordUpdateModal || state.SuccessOpen || state.isErrOpen;

  return (
    <div className="container">
      {showBackdrop && (
        <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
      )}

      {state.SuccessOpen && (
        <div className="modal fade show" style={{ display: 'block', zIndex: 1060 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content cdb-confirm-box-msg success-popup">
              <div className="modal-header">
                <h5 className="modal-title">Success</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => {
                    setState(prev => ({ ...prev, SuccessOpen: false }));
                    logout();
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p className="popup-message">{state.api_error_message}</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setState(prev => ({ ...prev, SuccessOpen: false }));
                    logout();
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {state.isErrOpen && (
        <div className="modal fade show" style={{ display: 'block', zIndex: 1060 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content cdb-confirm-box-msg error-popup">
              <div className="modal-header">
                <h5 className="modal-title">Error</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setState(prev => ({ ...prev, isErrOpen: false }))}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p className="popup-message">{state.api_error_message}</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={() => setState(prev => ({ ...prev, isErrOpen: false }))}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {state.showPasswordUpdateModal && (
        <div className="modal fade show" style={{ display: 'block', zIndex: 1050 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Change Password</h5>
                {!((location.state && 
                    (location.state.is_first_login === "1" || 
                    location.state.password_update_flag === true))) && (
                  <button
                    type="button"
                    className="close"
                    onClick={() => setState(prev => ({ ...prev, showPasswordUpdateModal: false }))}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                )}
              </div>
              <div className="modal-body">
                <form onSubmit={handlemailSubmitpass}>
                  <div className="form-group">
                    <label htmlFor="newPassword">New Password</label>
                    <div className="input-with-icon">
                      <input
                        type={state.isViewpass ? "password" : "text"}
                        id="newPassword"
                        name="npass"
                        placeholder="Enter Password"
                        className="form-control"
                        value={state.npass}
                        onChange={(e) => setState(prev => ({ ...prev, npass: e.target.value }))}
                      />
                      <span 
                        className="password-toggle-icon"
                        onClick={() => viewpass(1)}
                      >
                        <img
                          src={viewIcon}
                          alt="Toggle password visibility"
                        />
                      </span>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="confirmPassword">Confirm Password</label>
                    <div className="input-with-icon">
                      <input
                        type={state.isViewpass1 ? "password" : "text"}
                        id="confirmPassword"
                        name="cpass"
                        placeholder="Confirm Password"
                        className="form-control"
                        onChange={comparepass}
                      />
                      <span 
                        className="password-toggle-icon"
                        onClick={() => viewpass(2)}
                      >
                        <img
                          src={viewIcon}
                          alt="Toggle password visibility"
                        />
                      </span>
                    </div>
                    {state.passerr && (
                      <div className="invalid-feedback d-block">
                        {state.passerr}
                      </div>
                    )}
                  </div>
                  <div className="text-center mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg"
                      disabled={state.isSpin}
                    >
                      {state.isSpin ? (
                        <>
                          <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                          Updating...
                        </>
                      ) : (
                        "Update"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="header-area">
        <div className="logout-btn-holder text-right">
          <PEButton element_id="dashboard_logout"
            type="button"
            onClick={logout}
            className="btn btn-outline-primary rounded-circle"
          >
            <i className="fa fa-power-off"></i>
          </PEButton>
        </div>
        <div className="text-center">
          <img src={logo} className="img-responsive logo30" alt="Logo" />
        </div>
      </div>
      <div className="card-holder">
        <div className="row mt-4">
          <div className="col-sm-6 mb-2">
            {/* AT-2072 | Vaibhav Sawant | 06-09-2023 | Adding variables in state for create_view */}
            <PEDiv element_id="dashboard_createview"
              className="card text-center"
              onClick={() =>
                history.push({
                  pathname: "/View",
                  state: {
                    view_id: "",
                    fieldslist: [],
                    effective_designation_id: effective_designation_id,
                    event_name: "",
                    bucket_name: "",
                    component_mapping: "",
                    view_name: "",
                    api_token: api_token,
                    flag: "C",
                    payloadTile: true,
                  },
                })
              }
            >
              <div className="card-body">
                <p className="card-text">Create View</p>
              </div>
            </PEDiv>
          </div>
          <PEDiv element_id="dashboard_viewlist" className="col-sm-6">
            <div
              className="card text-center"
              onClick={() => props.history.push("ViewList")}
            >
              <div className="card-body">
                <p className="card-text">View List</p>
              </div>
            </div>
          </PEDiv>
          <PEDiv  element_id="dashboard_vendorfield" className="col-sm-6 mt-4">
            <div
              className="card text-center"
              onClick={() => props.history.push("Vendor_specific_fields")}
            >
              <div className="card-body">
                <p className="card-text">Vendor Specific Fields</p>
              </div>
            </div>
          </PEDiv>
          {/*------not needed----- */}
          {/* <div className="col-sm-6 mt-4">
            <div
              className="card text-center"
              onClick={() => props.history.push("Nd_Fields")}
            >
              <div className="card-body">
                <p className="card-text">ND Fields</p>
              </div>
            </div>
          </div> */}
          <PEDiv element_id="dashboard_payload"
            className={
              effective_designation_id == ""
                ? "col-sm-6 mt-4 disabletile"
                : "col-sm-6 mt-4"
            }
          >
            <div
              className="card text-center"
              onClick={() =>
                window.location.assign(
                  process.env.REACT_APP_PAYLOAD_VIEW +
                    "/payload?api_token=" +
                    api_token +
                    "&desc_id=" +
                    effective_designation_id +
                    "&uid=" +
                    localStorage.getItem("in_userid")
                )
              }
            >
              <div className="card-body">
                <p className="card-text">
                  Payload{" "}
                  {effective_designation_id == "" && (
                    <div>
                      <img className="t10-r10-25" src={loader} />
                    </div>
                  )}
                </p>
              </div>
            </div>
          </PEDiv>
          {/* AT-2018 | AT-2260 | Ankur Makavana | 03/08/2023 | create new screen for transformation */}
          <PEDiv element_id="dashboard_transformation" className="col-sm-6 mt-4">
            <div
              className="card text-center"
              onClick={() => props.history.push("Transformation")}
            >
              <div className="card-body">
                <p className="card-text">Transformation</p>
              </div>
            </div>
          </PEDiv>
          {/* AT-1659 | AT-2299 | Ankur Makavana | 12/08/2023 | show ui and api performance payload on ui */}
          <PEDiv  element_id="dashboard_performance" className="col-sm-6 mt-4">
            <div
              className="card text-center"
              onClick={() => props.history.push("Performance_view")}
            >
              <div className="card-body">
                <p className="card-text">Performance</p>
              </div>
            </div>
          </PEDiv>
          <PEDiv element_id="dashboard_cache" className="col-sm-6 mt-4">
            <div
              className="card text-center"
              onClick={() => props.history.push("Cache")}
            >
              <div className="card-body">
                <p className="card-text">Cache</p>
              </div>
            </div>
          </PEDiv>
          <PEDiv element_id="dashboard_switch" className="col-sm-6 mt-4">
            <div
              className="card text-center"
              onClick={() => props.history.push("Switch")}
            >
              <div className="card-body">
                <p className="card-text">Switch</p>
              </div>
            </div>
          </PEDiv>
          <PEDiv element_id="dashboard_dropdownMaster" className="col-sm-6 mt-4">
            <div
              className="card text-center"
              onClick={() => props.history.push("Dropdown_master")}
            >
              <div className="card-body">
                <p className="card-text">Dropdown Master</p>
              </div>
            </div>
          </PEDiv>
          <PEDiv element_id="dashboard_unblockUser" className="col-sm-6 mt-4">
            <div
              className="card text-center"
              onClick={() => props.history.push("Unblock_user")}
            >
              <div className="card-body">
                <p className="card-text">Unblock User</p>
              </div>
            </div>
          </PEDiv>
          {/* <div className="col-sm-6 mt-4">
            <div
              className="card text-center"
              onClick={() => props.history.push("Permission")}
            >
              <div className="card-body">
                <p className="card-text">Permission</p>
              </div>
            </div>
          </div> */}
          <PEDiv element_id="dashboard_userFunctionality" className="col-sm-6 mt-4">
            <div
              className="card text-center"
              onClick={() => props.history.push("User_functionality")}
            >
              <div className="card-body">
                <p className="card-text">User Functionality</p>
              </div>
            </div>
          </PEDiv>




          <div className="col-sm-6 mt-4">
            <div
              className="card text-center"
              onClick={() => props.history.push("Element_permission")}
            >
              <div className="card-body">
                <p className="card-text">Element Permission</p>
              </div>
            </div>
          </div>
          <div className="col-sm-6 mt-4">
            <div
              className="card text-center"
              onClick={() => props.history.push("Decrypt_payload")}
            >
              <div className="card-body">
                <p className="card-text">Decrpyt Payload</p>
              </div>
            </div>
          </div>
          <div className="col-sm-6 mt-4">
            <div
              className="card text-center"
              onClick={() => props.history.push("Field_mapping")}
            >
              <div className="card-body">
                <p className="card-text">Field Mapping</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;